import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={{ paddingTop: '70px' }}>
      <div className="page-header">
        <h1>Privacy Policy</h1>
        <p>How we protect and handle your information</p>
      </div>
      <div className="container">
        <div className="policy-content">
          <h2>Introduction</h2>
          <p>At Saliheen Perfumes, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you visit our website or make a purchase from us.</p>

          <h2>Information We Collect</h2>
          <h3>Personal Information</h3>
          <p>We may collect personal details such as your name, email address, phone number, and shipping address.</p>

          <h3>Payment Information</h3>
          <p>When you make a purchase, we collect payment information such as credit/debit card details or other payment method details.</p>

          <h3>Technical Information</h3>
          <p>We may collect technical data such as your IP address, browser type, and operating system when you visit our website.</p>

          <h2>How We Use Your Information</h2>
          <ul>
            <li>To process and fulfill your orders.</li>
            <li>To communicate with you about your orders.</li>
            <li>To improve our website and services.</li>
            <li>To send promotional offers and updates (if you opt-in).</li>
          </ul>

          <h2>Data Security</h2>
          <p>We use industry-standard security measures to protect your personal information from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is 100% secure.</p>

          <h2>Third-Party Services</h2>
          <p>We may use third-party services (e.g., payment processors, shipping providers) to facilitate our services. These third parties have access to your information only to perform specific tasks on our behalf and are obligated not to disclose or use it for other purposes.</p>

          <h2>Your Rights</h2>
          <ul>
            <li>You have the right to access, update, or delete your personal information.</li>
            <li>You can opt-out of receiving promotional emails at any time.</li>
            <li>You can request a copy of the personal data we hold about you.</li>
          </ul>

          <h2>Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page, and we will notify you of significant changes via email or a notice on our website.</p>

          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:saliheenperfumes@gmail.com">saliheenperfumes@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
}
